import React, { useState, useEffect } from "react";
import { TextField, Button, Box, MenuItem, Select } from "@mui/material";
import style from "../../../../styles/gri/general.module.css";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DynamicStaticTable from "./StaticTables";
import DynamicStatic from "./DynamicTabeles";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import GRISidebar from "../../../../Layout/GRISidebar";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

function GRI306_5({ hide }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [tables, setTables] = useState([]);
  const [tables1, setTables1] = useState([]);
  const [tables2, setTables2] = useState([]);
  const [tables3, setTables3] = useState([]);
  const [unit, setUnit] = useState("");
  const [unit1, setUnit1] = useState("");
  const [unit2, setUnit2] = useState("");
  const [unit3, setUnit3] = useState("");
  const [total, setTotal] = useState(0);
  const [total1, setTotal1] = useState(0);
  const [total2, setTotal2] = useState(0);
  const [total3, setTotal3] = useState(0);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({
    wasteDataContext: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "benifitProvided",
      //   title:

      type: "array",
      //   letter: "a.",
      fields: [
        {
          fieldName: "typeOfWaste",
          title: "Type of Waste",
          type: "text",
          placeholder: "Enter Text",
          width: "42%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "text",
        //   width: "30%",
        //   placeholder: "Enter Text",
        //   value: unit,
        // },
        {
          fieldName: "quantity",
          title: "Value",
          type: "number",
          width: "42%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "benifitProvided",
      //   title:

      type: "array",
      //   letter: "a.",
      fields: [
        {
          fieldName: "typeOfWaste",
          title: "Type of Waste",
          type: "text",
          placeholder: "Enter Text",
          width: "45%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "text",
        //   width: "30%",
        //   placeholder: "Enter Text",
        //   value: unit1,
        // },
        {
          fieldName: "quantity",
          title: "Quantity",
          type: "number",
          width: "45%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      fieldName: "benifitProvided",
      //   title:

      type: "array",
      //   letter: "a.",
      fields: [
        {
          fieldName: "typeOfWaste",
          title: "Type of Waste",
          type: "text",
          placeholder: "Enter Text",
          width: "45%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "text",
        //   width: "30%",
        //   placeholder: "Enter Text",
        //   value: unit2,
        // },
        {
          fieldName: "quantity",
          title: "Quantity",
          type: "number",
          width: "45%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const inputData3 = [
    {
      fieldName: "benifitProvided",
      //   title:

      type: "array",
      //   letter: "a.",
      fields: [
        {
          fieldName: "typeOfWaste",
          title: "Disposal Type",
          type: "text",
          placeholder: "Enter Text",
          width: "45%",
        },
        {
          fieldName: "quantity",
          title: "Quantity",
          type: "number",
          width: "45%",
          placeholder: "Enter Number",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "text",
        //   width: "30%",
        //   placeholder: "Enter Text",
        //   value: unit3,
        // },
      ],
    },
  ];

  const defaultSegments = [
    "Hazardous Waste",
    "Non-Hazardous Waste",
    "Electronic Waste",
    "Food Waste",
    "Biowaste",
  ];

  const defaultSegments1 = [
    "Incineration (With energy recovery)",
    "Incineration (Without energy recovery)",
    "Landfilling",
  ];

  const defaultSegments2 = [
    "Incineration (With energy recovery)",
    "Incineration (Without energy recovery)",
    "Landfilling",
  ];

  const defaultSegments3 = ["Onsite Disposal", "Offline Disposal"];

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        const response = res.data.data.GRI300.wasteToDisposal;
        setFormData({
          dataCompilationContext: response?.dataCompilationContext,
          wasteDataContext: response?.wasteDataContext,
        });
        setTotal(response?.wasteDisposalByCompositionTotal?.value || 0); // Fallback to 0 if value is undefined
        setUnit(
          response?.wasteDisposalByCompositionTotal?.unit ||
            res?.data?.data?.GRI300?.wasteGenerated?.total?.unit ||
            ""
        ); // Fallback to an empty string if unit is undefined
        setTables(
          response?.wasteDisposalByComposition.length > 0
            ? [{ rows: response?.wasteDisposalByComposition || [] }]
            : inputData?.map((section) => ({
                fieldName: section?.fieldName,
                rows:
                  data?.[section?.fieldName]?.length > 0
                    ? data[section?.fieldName]
                    : defaultSegments.map((el) => ({ ["typeOfWaste"]: el })),
              }))
        ); // Fallback to an empty array if no data
        setTables1(
          response?.hazardousWasteDisposalBreakdown.length > 0
            ? [{ rows: response?.hazardousWasteDisposalBreakdown || [] }]
            : inputData1.map((section) => ({
                fieldName: section?.fieldName,
                rows:
                  data?.[section?.fieldName]?.length > 0
                    ? data[section?.fieldName]
                    : defaultSegments1.map((el) => ({ ["typeOfWaste"]: el })),
              }))
        );
        setTotal1(response?.hazardousWasteDisposalBreakdownTotal?.value || 0);
        setUnit1(response?.hazardousWasteDisposalBreakdownTotal?.unit || 0);
        setTables2(
          response?.nonHazardousWasteDisposalBreakdown?.length > 0
            ? [{ rows: response?.nonHazardousWasteDisposalBreakdown || [] }]
            : inputData2.map((section) => ({
                fieldName: section?.fieldName,
                rows:
                  data?.[section?.fieldName]?.length > 0
                    ? data[section?.fieldName]
                    : defaultSegments2.map((el) => ({ ["typeOfWaste"]: el })),
              }))
        );
        setTotal2(
          response?.nonHazardousWasteDisposalBreakdownTotal?.value || 0
        );
        setUnit2(response?.nonHazardousWasteDisposalBreakdownTotal?.unit || 0);
        setTables3(
          response?.wasteDiversionTotals?.length > 0
            ? [{ rows: response?.wasteDiversionTotals || [] }]
            : inputData3.map((section) => ({
                fieldName: section?.fieldName,
                rows:
                  data?.[section?.fieldName]?.length > 0
                    ? data[section?.fieldName]
                    : defaultSegments3.map((el) => ({ ["typeOfWaste"]: el })),
              }))
        );
        setTotal3(response?.wasteDiversionTotal?.value || 0);
        setUnit3(response?.wasteDiversionTotal?.unit || 0);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const updatedUnit = e.target.value; // Get the new unit value
    setUnit(updatedUnit);
    setTables((prev) =>
      prev.map((table) => ({
        ...table, // Spread the existing table object
        rows: table?.rows?.map((row) => ({
          ...row, // Spread each row object
          unit: updatedUnit, // Update the `unit` field
        })),
      }))
    );
  };

  const handleChange1 = (e) => {
    const updatedUnit = e.target.value; // Get the new unit value
    setUnit1(updatedUnit);
    setTables1((prev) =>
      prev.map((table) => ({
        ...table, // Spread the existing table object
        rows: table?.rows?.map((row) => ({
          ...row, // Spread each row object
          unit: updatedUnit, // Update the `unit` field
        })),
      }))
    );
  };

  const handleChange2 = (e) => {
    const updatedUnit = e.target.value; // Get the new unit value
    setUnit2(updatedUnit);
    setTables2((prev) =>
      prev.map((table) => ({
        ...table, // Spread the existing table object
        rows: table?.rows?.map((row) => ({
          ...row, // Spread each row object
          unit: updatedUnit, // Update the `unit` field
        })),
      }))
    );
  };

  const handleChange3 = (e) => {
    const updatedUnit = e.target.value; // Get the new unit value
    setUnit3(updatedUnit);
    setTables3((prev) =>
      prev.map((table) => ({
        ...table, // Spread the existing table object
        rows: table?.rows?.map((row) => ({
          ...row, // Spread each row object
          unit: updatedUnit, // Update the `unit` field
        })),
      }))
    );
  };

  const handleSubmit = async () => {
    if (!disabled) {
      const dataToSend = {
        ...formData,
        wasteDisposalByCompositionTotal: {
          value: total,
          unit: unit,
        },
        hazardousWasteDisposalBreakdownTotal: {
          value: total1,
          unit: unit,
        },
        nonHazardousWasteDisposalBreakdownTotal: {
          value: total2,
          unit: unit,
        },
        wasteDiversionTotal: {
          value: total3,
          unit: unit,
        },
        wasteDisposalByComposition: tables[0]?.rows,
        hazardousWasteDisposalBreakdown: tables1[0]?.rows,
        nonHazardousWasteDisposalBreakdown: tables2[0]?.rows,
        wasteDiversionTotals: tables3[0]?.rows,
      };
      try {
        await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          wasteToDisposal: { ...dataToSend },
          submitted306_5: true,
        })
          .then((res) => navigate(`/gri/gri300/308-1/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/308-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p className={style.section_heading}>306 : Waste</p>}
      <p
        className={style.main_heading}
        style={{
          // marginTop: "2.5rem",

          marginBottom: hide ? "-1rem" : "0.5rem",
          display: "flex",
        }}
      >
        306-5: Waste DIRECTED to disposal
      </p>
      <p className={style.ques_heading}>
        a. Provide the total weight of waste directed to disposal by composition
        of the waste?
      </p>
      <Box sx={{ display: "flex", ml: 2 }}>
        <p className={style.ques_heading}>Unit</p>
        <Select
          sx={{
            height: "2rem",
            width: "24%",
            mt: "1rem",
            ml: "5px",
          }}
          name={`unit`}
          value={unit || ""}
          placeholder="Select"
          onChange={(e) => handleChange(e)}
          displayEmpty
          size="small"
          disabled={disabled}
          //  fullWidth
          // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          {["Kg", "Tonns"].map((data, index) => (
            <MenuItem key={index} value={data}>
              {data}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <DynamicStatic
        {...{
          inputData: inputData,
          tables,
          setTables,
          unit,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments: defaultSegments,
          parameter: "typeOfWaste",
          total,
          setTotal,
          disabled: disabled,
          hide: hide,
        }}
      />
      <p className={style.ques_heading}>
        b. What is the total weight of hazardous waste directed to disposal in
        metric tons?
      </p>
      <Box sx={{ display: "flex", ml: 2 }}>
        <p className={style.ques_heading}>Unit</p>
        <Select
          sx={{
            height: "2rem",
            width: "24%",
            mt: "1rem",
            ml: "5px",
          }}
          disabled
          name={`unit`}
          value={unit || ""}
          placeholder="Select"
          onChange={(e) => handleChange1(e)}
          displayEmpty
          size="small"
          //  fullWidth
          // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          {["Kg", "Tonns"].map((data, index) => (
            <MenuItem key={index} value={data}>
              {data}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <DynamicStatic
        {...{
          inputData: inputData1,
          tables: tables1,
          setTables: setTables1,
          unit: unit1,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments: defaultSegments1,
          parameter: "typeOfWaste",
          total: total1,
          setTotal: setTotal1,
          disabled: disabled,
          hide: hide,
        }}
      />
      <p className={style.ques_heading}>
        c. What is the total weight of non-hazardous waste directed to disposal
        in metric tons?
      </p>
      <Box sx={{ display: "flex", ml: 2 }}>
        <p className={style.ques_heading}>Unit</p>
        <Select
          disabled
          sx={{
            height: "2rem",
            width: "24%",
            mt: "1rem",
            ml: "5px",
          }}
          name={`unit`}
          value={unit || ""}
          placeholder="Select"
          onChange={(e) => handleChange2(e)}
          displayEmpty
          size="small"
          //  fullWidth
          // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          {["Kg", "Tonns"].map((data, index) => (
            <MenuItem key={index} value={data}>
              {data}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <DynamicStatic
        {...{
          inputData: inputData2,
          tables: tables2,
          setTables: setTables2,
          unit: unit2,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments: defaultSegments2,
          parameter: "typeOfWaste",
          total: total2,
          setTotal: setTotal2,
          disabled: disabled,
          hide: hide,
        }}
      />
      <p className={style.ques_heading}>
        d. For every directed disposal outlined in Disclosures 306-5-b and
        306-5-c, detail the total weight in metric tons of hazardous waste and
        non-hazardous waste diverted from disposal.
      </p>
      <Box sx={{ display: "flex", ml: 2 }}>
        <p className={style.ques_heading}>Unit</p>
        <Select
          sx={{
            height: "2rem",
            width: "24%",
            mt: "1rem",
            ml: "5px",
          }}
          name={`unit`}
          value={unit || ""}
          disabled
          placeholder="Select"
          onChange={(e) => handleChange3(e)}
          displayEmpty
          size="small"
          //  fullWidth
          // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          {["Kg", "Tonns"].map((data, index) => (
            <MenuItem key={index} value={data}>
              {data}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <DynamicStaticTable
        {...{
          inputData: inputData3,
          tables: tables3,
          setTables: setTables3,
          unit: unit3,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments: defaultSegments3,
          parameter: "typeOfWaste",
          total: total3,
          setTotal: setTotal3,
          disabled: disabled,
        }}
      />
      <Box>
        <p
          className={style.ques_heading}
          style={{
            // marginTop: "2.5rem",
            marginRight: "1rem",
            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          e. Provide contextual information necessary to understand the data and
          how the data has been compiled.
        </p>

        <TextField
          placeholder="Enter Text"
          name="wasteDataContext"
          fullWidth
          sx={{ padding: " 0px 24px" }}
          value={formData?.wasteDataContext}
          onChange={(e) =>
            setFormData(
              // Keep previous values intact
              { wasteDataContext: e.target.value } // Update wasteDataContext with the new value
            )
          }
          disabled={disabled}
        />
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
}

export default GRI306_5;
